export default {
  screens: [
    {
      type: 'intro',
      title: 'La nature',
      content:
        "Source d'inspiration intarissable, foisonnante et symbolique, la nature est un thème majeur de l'histoire de la Maison.",
      idYt: 'GUF98BCNd3c',
      videoCover: 'world/wild/video.jpg',
      desktop: {
        cover: 'world/wild/cover-1.jpg'
      },
      mobile: {
        cover: 'world/wild/mobile-cover-1.jpg',
        contentStyle: { width: '100%', paddingBottom: '120px' },
        coverStyle: {
          width: '110%',
          top: '87%',
          bottom: '40px',
          left: '0',
          position: 'absolute'
        }
      },
      isCover: true
    },
    {
      type: 'memento',
      img: 'world/wild/memento.jpg',
      content:
        "Faune, flore et insectes transformés en joyaux par la main de l'artisan racontent une nature sauvage, vivante et gracile. <br><br>Riche en références, le répertoire botanique de Chaumet est un choix de distinction.",
      cover: 'world/wild/cover-2.jpg',
      isCover: true
    },
    {
      type: 'staircase',
      desktop: {
        leftImg: 'world/wild/staircaseLeft.jpg',
        middleImg: 'world/wild/staircaseMiddle.jpg',
        rightImg: 'world/wild/staircaseRight.jpg',
        cover: 'world/wild/cover-3.jpg'
      },
      mobile: {
        leftImg: 'world/wild/staircaseLeft.jpg',
        middleImg: 'world/wild/staircaseMiddle.jpg',
        rightImg: 'world/wild/staircaseRight.jpg',
        cover: 'world/wild/mobile-cover-3.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: '85%',
          top: '-15%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      },
      content:
        "Choix de Joséphine, le blé, symbole d'abondance, se ploie sous le vent depuis l'origine. Chaumet ne cesse de revisiter ce motif à l'image du diadème Epis de Blé de 1811.",
      isCover: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/fr/worlds/wild.js